import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import ModalPopUp from "@/Components/common/ModalPopUp";
import {
  fetchBookedCandidates,
  setBookedCandidatesLoading,
  showFilterModal,
  updateFilters,
  updatePagination,
  reStateFilters,
  deSelectAllCandidate,
} from "@/reducers/client_candidates/candidatesbooked";
import { fetchFiltersData } from "@/reducers/clientscandidates";

import CalendarFilter from "../../../ListingFilters/CalendarFilter";
import ComplianceStatusFilter from "../../../ListingFilters/ComplianceStatusFilter";
import DropDownFilter from "../../../ListingFilters/DropDownFilter";
import FilterModalBottomAction from "../../../ListingFilters/FilterModalBottomAction";
import { FilterModalTop } from "../../../ListingFilters/FilterModalTop";
import MilesFilter from "../../../ListingFilters/MilesFilter";
import SessionTypeFilter from "../../../ListingFilters/SessionTypeFilter";
import TextFieldFilter from "../../../ListingFilters/TextFieldFilter";
/**
 * Function for handling the filter modal functionality.
 */
export const FilterModal = () => {
  const dispatch = useDispatch();
  const { filters, showFilters, pagination } = useSelector(
    (state) => state.clientCandidatesBooked,
  );
  const { filterLists } = useSelector((state) => state.clientsCandidates);
  /**
   * A function that handles the closing of something.
   *
   * @param {boolean} fromBtn - indicates if the function was called from a button
   * @return {void}
   */
  const handleClose = (fromBtn = false) => {
    if (fromBtn) {
      dispatch(reStateFilters());
    }
    dispatch(showFilterModal(false));
  };
  useEffect(() => {
    dispatch(fetchFiltersData());
  }, []);
  /**
   * Function to handle the application of changes.
   *
   */
  const handleApply = () => {
    dispatch(setBookedCandidatesLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllCandidate());
    dispatch(fetchBookedCandidates(filters));
    handleClose();
  };
  /**
   * Function to handle reset. Dispatches multiple actions to update filters, set booked candidates loading, update pagination, fetch booked candidates, and then closes the modal.
   */
  const handleReset = () => {
    dispatch(updateFilters());
    dispatch(setBookedCandidatesLoading(true));
    dispatch(
      updatePagination({
        ...pagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(deSelectAllCandidate());
    dispatch(
      fetchBookedCandidates({
        search: filters.search,
      }),
    );
    handleClose();
  };
  return (
    <ModalPopUp
      show={showFilters}
      panelClass="max-w-[774px]"
      onClose={() => {
        handleClose(true);
      }}
    >
      <div className="grid gap-6">
        <div className="grid gap-[12px]">
          <div className="grix gap-4">
            <FilterModalTop
              handleClose={() => {
                handleClose(true);
              }}
            />
          </div>
          <div className="grid grid-cols-1 gap-x-6 gap-y-[18px] sm:grid-cols-2">
            <SessionTypeFilter
              active={filters.sessionType}
              handleClick={(value) => {
                dispatch(updateFilters({ sessionType: value }));
              }}
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ contractReferenceNo: value }));
              }}
              label="Contract Reference No."
              value={filters.contractReferenceNo}
              filterId="contractReferenceNo"
              placeholder="Enter Reference No."
            />
            <DropDownFilter
              options={
                filterLists && filterLists?.allCandidates?.length > 0
                  ? filterLists?.allCandidates
                  : []
              } // this is the list of candidates
              id="candidateId"
              label="Candidate"
              placeholder="Select Candidate"
              value={filters.candidateId} // selected candidate
              handleChange={(value) => {
                dispatch(updateFilters({ candidateId: value }));
              }} // function to handle change of candidate
              isMultiple={true}
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ candidateReferenceNo: value }));
              }}
              label="Candidate Reference No."
              value={filters.candidateReferenceNo}
              filterId="candidateReferenceNo"
              placeholder="Enter Reference No."
            />
            <TextFieldFilter
              handleKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleApply();
                }
              }}
              handleChange={(value) => {
                dispatch(updateFilters({ candidateLicenseNo: value }));
              }}
              label="Prof. Registration No."
              value={filters.candidateLicenseNo}
              filterId="candidateLicenseNo"
              placeholder="GMC/NMC/GPhC"
            />
            <ComplianceStatusFilter
              value={filters.complianceStatus}
              handleChange={(value) => {
                dispatch(updateFilters({ complianceStatus: value }));
              }}
            />
            <DropDownFilter
              options={
                filterLists && filterLists?.allRoles?.length > 0
                  ? filterLists?.allRoles
                  : []
              } // this is the list of roles
              id="candidateRole"
              label="Role"
              placeholder="Select Role"
              value={filters.candidateRole} // selected role
              handleChange={(value) => {
                dispatch(updateFilters({ candidateRole: value }));
              }} // function to handle change of role
            />
            <MilesFilter
              value={filters.miles}
              handleChange={(value) => {
                dispatch(updateFilters({ miles: value }));
              }}
            />
          </div>
          <div className="_filter_calendar">
            <CalendarFilter
              label="Shift Date"
              dateFrom={filters.bookedDateFrom}
              dateTo={filters.bookedDateTo}
              handleChange={(value) => {
                dispatch(
                  updateFilters({
                    bookedDateFrom: value.dateFrom,
                    bookedDateTo: value.dateTo,
                  }),
                );
              }}
            />
          </div>
        </div>
        <FilterModalBottomAction
          applyFunc={handleApply}
          resetFunc={handleReset}
        />
      </div>
    </ModalPopUp>
  );
};
